export default __webpack_public_path__ + "static/media/SiteTagWithoutDevice.4c973156.png";